import Reveal from "./Reveal";
import { Megaphone, LineChart, CalendarClock, ArrowUpRight } from "lucide-react";

const IMG_PR =
  "https://images.unsplash.com/photo-1575507479993-7bb702d5e966?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHw0fHxwdWJsaWMlMjByZWxhdGlvbnMlMjBtZWRpYSUyMGV2ZW50fGVufDB8fHx8MTc4MzYwNjIxOHww&ixlib=rb-4.1.0&q=85";
const IMG_DM =
  "https://images.unsplash.com/photo-1519389950473-47ba0277781c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwxfHxkaWdpdGFsJTIwbWFya2V0aW5nJTIwYWdlbmN5JTIwdGVhbXxlbnwwfHx8fDE3ODM2MDYyMDN8MA&ixlib=rb-4.1.0&q=85";
const IMG_EV =
  "https://images.unsplash.com/photo-1544531586-fde5298cdd40?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwyfHxwdWJsaWMlMjBzcGVha2luZyUyMGV2ZW50fGVufDB8fHx8MTc4MzYwNjIwMnww&ixlib=rb-4.1.0&q=85";

const services = [
  {
    icon: Megaphone,
    title: "PR & Communications",
    img: IMG_PR,
    desc: "Reputation management, media relations, messaging strategy and stakeholder communications that build credibility and lasting influence.",
    tags: ["Media Relations", "Reputation", "Messaging"],
  },
  {
    icon: LineChart,
    title: "Digital Marketing",
    img: IMG_DM,
    desc: "Integrated digital campaigns, content, social and performance strategies that amplify reach and turn attention into measurable engagement.",
    tags: ["Social", "Content", "Campaigns"],
  },
  {
    icon: CalendarClock,
    title: "Events & Conferences",
    img: IMG_EV,
    desc: "End-to-end conferences, summits, awards and exhibitions — from concept and curation to flawless on-ground delivery.",
    tags: ["Summits", "Awards", "Exhibitions"],
  },
];

const Services = () => {
  return (
    <section id="services" data-testid="services-section" className="py-20 sm:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal>
          <div className="max-w-2xl">
            <p className="text-xs uppercase tracking-widest text-[#D91C29] font-semibold">What we do</p>
            <h2 className="font-serif-display text-3xl sm:text-4xl font-bold text-[#0B1B3D] tracking-tight mt-3">
              Three disciplines, one integrated story
            </h2>
            <p className="mt-4 text-slate-600 leading-relaxed">
              We bring public relations, digital marketing and world-class event delivery
              under one roof to create experiences that move audiences and shape agendas.
            </p>
          </div>
        </Reveal>

        <div className="mt-14 grid md:grid-cols-3 gap-7">
          {services.map((s, i) => {
            const Icon = s.icon;
            return (
              <Reveal key={s.title} delay={i * 0.12}>
                <div
                  data-testid={`service-card-${i}`}
                  className="group h-full rounded-2xl border border-slate-200 bg-white overflow-hidden hover:shadow-xl hover:-translate-y-1 transition-transform transition-shadow duration-300"
                >
                  <div className="relative h-48 overflow-hidden">
                    <img
                      src={s.img}
                      alt={s.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#0B1B3D]/70 to-transparent" />
                    <div className="absolute top-4 left-4 w-11 h-11 rounded-xl bg-white/95 backdrop-blur flex items-center justify-center shadow">
                      <Icon size={20} className="text-[#D91C29]" />
                    </div>
                  </div>
                  <div className="p-6">
                    <div className="flex items-start justify-between">
                      <h3 className="font-serif-display text-xl font-bold text-[#0B1B3D]">{s.title}</h3>
                      <ArrowUpRight size={20} className="text-slate-300 group-hover:text-[#D91C29] transition-colors" />
                    </div>
                    <p className="mt-3 text-sm text-slate-600 leading-relaxed">{s.desc}</p>
                    <div className="mt-5 flex flex-wrap gap-2">
                      {s.tags.map((t) => (
                        <span key={t} className="text-xs font-medium text-[#0B1B3D] bg-slate-100 rounded-full px-3 py-1">
                          {t}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
